import apiClient from 'services/api';

export default TopicID => {
  return apiClient
    .get(`Topic/GetAssignedSkills/${TopicID}`)
    .then(result => {
      return result.data?.Result ?? [];
    })
    .catch(err => {
      return {
        error: err?.response?.data?.message ?? 'Skills fetch failed' // eslint-disable-line
      };
    });
};
